<!--
 * @Description: 合作伙伴详情
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-11-25 10:35:17
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <CosViewContent
        header
        :title="data?.customerInfo?.customerName"
        :sellerName="data?.customerInfo?.sellerName"
        customLabel="联系人姓名"
        :customValue="data?.contact?.name"
      >
        <a-tabs @change="changeTabs">
          <a-tab-pane key="1" tab="基本信息">
            <baseMessage :disabled="true" formItemView :data="data" :type="type" :hideOk="true" />
          </a-tab-pane>
          <a-tab-pane key="2" tab="联系人">
            <TabsContacts :contactRefId="route.query.cosId" appId="cos_fbu" :hideOk="true" />
          </a-tab-pane>
        </a-tabs>
      </CosViewContent>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import TabsContacts from '@/components/TabsContacts/index.vue'
import baseMessage from '@/views/gucangSales/customerCenter/components/baseMessage.vue'
import { potentialDetail } from '@/api/gucangSales/customerCenter'
import { useRoute } from 'vue-router'
defineProps({
  type: {
    type: String
  }
})
const route = useRoute()
const data = ref({})
const loading = ref(false)
// 获取详情
const fetch = () => {
  if (route.query.cosId) {
    loading.value = true
    potentialDetail(route.query.cosId)
      .then((res) => {
        data.value = res.data
      })
      .finally(() => {
        loading.value = false
      })
  }
}
// 标签页切换
const changeTabs = (v: string) => {
  if (v === '1') {
    fetch()
  }
}
onMounted(() => {
  fetch()
})
// const permissionBasic = {
//   transfer: 'fbu_clients_transfer_btn',
//   follow_add: 'fbu_clients_follow_add_btn',
//   visitor_add: 'fbu_clients_visitor_add_btn',
//   edit: 'fbu_clients_edit_btn'
// }
// const permissionFollow = {
//   add: 'fbu_clients_follow_add_btn',
//   edit: 'fbu_clients_follow_edit_btn',
//   del: 'fbu_clients_follow_del_btn',
//   comment: 'fbu_clients_follow_comment_btn'
// }
// const permissionBuss = {
//   add: 'fbu_clients_buss_add_btn',
//   edit: 'fbu_clients_buss_edit_btn',
//   del: 'fbu_clients_buss_del_btn'
// }
// const permissionConcat = {
//   add: 'fbu_clients_concat_add_btn',
//   edit: 'fbu_clients_concat_edit_btn',
//   del: 'fbu_clients_concat_del_btn'
// }
</script>
<script lang="ts">
export default {
  name: 'FbuClientsView'
}
</script>
<style lang="scss" scoped></style>
